<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-card :loading="loading">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-form ref="form">
                <v-row>
                  <v-col md="4" sm="6" cols="12">
                    <v-text-field 
                      label="Public name"
                      outlined
                      dense
                      v-model="user.public_name"
                      :rules="[
                        v => !!v || 'This field is required'
                      ]"
                    />
                  </v-col>
                  <v-col md="4" sm="6" cols="12">
                    <v-text-field 
                      label="Phone number"
                      outlined
                      dense
                      v-model="user.phone"
                      :rules="[
                        v => !!v || 'This field is required'
                      ]"
                    />
                  </v-col>
                  <v-col md="4" sm="12" cols="12">
                    <UploadFile
                      label="Image"
                      :modelValue.sync="user.image"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-btn color="success" @click.prevent="submitForm">Save</v-btn>
                    <v-btn color="primary" class="ml-2" @click.prevent="dialog = true">Verifiy new email</v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col lg="3" md="4" sm="6" cols="12" v-for="email in emails">
                    <v-card>
                      <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                          <div class="d-block text-truncate">
                            {{ email }}
                          </div>
                          <v-chip label small class="flex-shrink-0" color="success" >
                            <v-icon left small>
                              mdi-check
                            </v-icon>
                            Verified
                          </v-chip>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <multiDialog
      :dialog="dialog"
      :deleting="false"
      :resourceKeys="resourceKeys"
      :newResource="resource"
      :loading="loading"
      :resourceSettings="resourceSettings"
      @closeDialog="dialog = false"
      @postResource="postResource"
    />
  </v-row>
</template>

<script>
import UploadFile from '../components/uploadFile.vue';
import multiDialog from '@/components/multiDialog.vue'

export default {
  data() {
    return {
      loading: false,
      dialog: false,
      emails: [],
      resourceKeys: [
        {
          name: 'email',
          label: 'email',
          type: 'text',
          required: true,
          readonly: true,
          email: true
        },
      ],
      resource: {
        email: null
      },
      resourceSettings: {
        resourceName: 'verify_email'
      },

      user: {
        public_name: this.$store.state.user.public_name,
        phone: this.$store.state.user.phone,
        image: this.$store.state.user.image,
      }
    };
  },
  components: { UploadFile, multiDialog },
  methods: {
    async postResource(r) {
      this.loading = true
      await this.$store.dispatch('postResource', { resource: '/verify-email-aws', value: {email: r.email} })
      this.loading = false
    },
    async submitForm() {
      if (this.$refs.form.validate()) {
        this.loading = true
        await this.$store.dispatch('postResource', { resource: '/profile/update', value: this.user })
        await this.$store.dispatch('getUser')
        this.loading = false
      }
    }
  },
  async created() {
    const resp = await this.$store.dispatch('getResource', { resource: "/aws-verified" })
     this.emails = resp.emails
  }
}
</script>